import axios from 'axios';

// En localhost usa el backend local; en producción/pruebas usa el dominio remoto
const IS_LOCALHOST = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_BASE_URL = IS_LOCALHOST ? 'http://localhost:5028/api' : 'https://comex-analitica.alianzateam.com/api';
/** Base URL del backend sin /api (para fetch directos) */
export const API_BASE = IS_LOCALHOST ? 'http://localhost:5028' : 'https://comex-analitica.alianzateam.com';

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_proveedor');
      window.location.reload();
    }
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Servicios de autenticación
export const authService = {
  login: (username: string, password: string) =>
    api.post('/auth/login', { username, password }),

  register: (data: any) =>
    api.post('/auth/registro-simple', data),

  getAzureConfig: () =>
    api.get('/auth/azure-config'),

  loginWithAzure: (token: string, user: any) =>
    api.post('/auth/azure-login', { token, user }),
};

// Servicios de rutas
export const rutasService = {
  getTablaCompleta: (params?: {
    page?: number;
    per_page?: number;
    sort_by?: string;
    sort_order?: string;
    origen_ciudad?: string;
    destino_ciudad?: string;
    tipo_vehiculo?: string;
    tipo_carga?: string;
    tipo_carroceria?: string;
    proveedor_username?: string;
  }) =>
    api.get('/rutas/tabla-real', { params }),

  getOpcionesFiltros: () =>
    api.get('/rutas/opciones-filtros'),

  guardarPropuestaProveedor: (data: {
    proveedor: string;
    origen_ciudad: string;
    destino_ciudad: string;
    tipo_vehiculo: string;
    tipo_carga: string;
    tipo_carroceria: string;
    valor_propuesto: number | null;
    comentarios: string | null;
    porcentaje_intermediacion: number | null;
    costos_adicionales: number | null;
    ciudades_devolucion: Array<{ ciudad_devolucion: string; valor_adicional: number | null }>;
  }) =>
    api.post('/rutas/guardar-propuesta-proveedor', data),

  getCiudadesDevolucion: (params: {
    origen_ciudad: string;
    destino_ciudad: string;
    tipo_vehiculo: string;
    tipo_carga: string;
    tipo_carroceria: string;
  }) =>
    api.get('/rutas/ciudades-devolucion', { params }),
};

// Servicios de preguntas
export const preguntasService = {
  getAll: () =>
    api.get('/preguntas'),

  crear: (pregunta: string) =>
    api.post('/preguntas/crear', { pregunta }),

  responder: (pregunta_id: number, respuesta: string) =>
    api.post('/admin/preguntas/responder', { pregunta_id, respuesta }),
};

// Servicios de proveedores
export const proveedorService = {
  getAll: () =>
    api.get('/proveedores'),
};

// Servicios de salud
export const healthService = {
  check: () =>
    api.get('/health'),

  validateMySQL: () =>
    api.get('/validate-mysql'),
};

export default api;

